export default "__VITE_ASSET__B7HEv3Z1__"